import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('/page/index.vue')
const Login = () => import('/page/Login/login.vue')
const Register = () => import('/page/Login/register.vue')
const FindPwd = () => import('/page/Login/findPwd.vue')
const BindWeixin = () => import('/page/Login/bindWeixin.vue')
const Home = () => import('/page/Home/home.vue')
const GoodS = () => import('/page/Goods/goods.vue')
const Extend = () => import('/page/Goods/extend.vue')
const goodsDetails = () => import('/page/Goods/goodsDetails.vue')
const extendDetails = () => import('/page/Goods/extendDetails.vue')
const Cart = () => import('/page/Cart/cart.vue')
const order = () => import('/page/Order/order.vue')
const user = () => import('/page/User/user.vue')
const orderList = () => import('/page/User/children/orderList.vue')
const userInfo = () => import('/page/User/children/userInfo.vue')
const addressList = () => import('/page/User/children/addressList.vue')
const reRelationship = () => import('/page/User/children/reRelationship.vue')
const reGoods = () => import('/page/User/children/reGoods.vue')
const receiveAmount = () => import('/page/User/children/receiveAmount.vue')
const checkout = () => import('/page/Checkout/checkout.vue')
const payment = () => import('/page/Order/payment.vue')
const paymentMWEB = () => import('/page/Order/paymentMWEB.vue')
const Search = () => import('/page/Search/search.vue')
const RefreshSearch = () => import('/page/Refresh/refreshsearch.vue')
const RefreshGoods = () => import('/page/Refresh/refreshgoods.vue')
const orderDetail = () => import('/page/User/children/orderDetail.vue')
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [
        {path: 'home', component: Home},
        {path: 'goods', component: GoodS},
        {path: 'extend', component: Extend},
        {path: 'goodsDetails', name: 'goodsDetails', component: goodsDetails},
        {path: 'extendDetails', name: 'extendDetails', component: extendDetails},
        {path: '/refreshgoods', name: 'refreshgoods', component: RefreshGoods}
      ]
    },
    {path: '/login', name: 'login', component: Login},
    {path: '/register', name: 'register', component: Register},
    {path: '/findPwd', name: 'findPwd', component: FindPwd},
    {path: '/bindWeixin', name: 'bindWeixin', component: BindWeixin},
    {path: '/cart', name: 'cart', component: Cart},
    {path: '/refreshsearch', name: 'refreshsearch', component: RefreshSearch},
    {
      path: '/order',
      name: 'order',
      component: order,
      children: [
        {path: 'payment', name: 'payment', component: payment},
        {path: 'paymentMWEB', name: 'paymentMWEB', component: paymentMWEB},
        {path: '/search', name: 'search', component: Search}
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      redirect: '/user/orderList',
      children: [
        {path: 'orderList', name: '订单列表', component: orderList},
        {path: 'orderDetail', name: '订单详情', component: orderDetail},
        {path: 'userInfo', name: '账户资料', component: userInfo},
        {path: 'addressList', name: '收货地址', component: addressList},
        {path: 'reRelationship', name: '推荐关系', component: reRelationship},
        {path: 'reGoods', name: '推荐商品', component: reGoods},
        {path: 'receiveAmount', name: '收入明细', component: receiveAmount}
      ]
    },
    {path: '/checkout', name: 'checkout', component: checkout},
    {path: '*', redirect: '/home'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js